export type ClassBlob = Record<string, unknown>;

export function classBlobOf(value: unknown): ClassBlob | null {
    return value !== null && typeof value === 'object' && !Array.isArray(value)
        ? value as ClassBlob
        : null;
}
